import { useCallback } from 'react'
import { useAuthStore } from '../stores/authStore'
import { authService } from '../services/authService'

export const useAuth = () => {
  const user = useAuthStore((state) => state.user)
  const token = useAuthStore((state) => state.token)
  const setLogin = useAuthStore((state) => state.setLogin)
  const logout = useAuthStore((state) => state.logout)
  const setUser = useAuthStore((state) => state.setUser)
  const hasPermission = useAuthStore((state) => state.hasPermission)
  const getAllowedCompanies = useAuthStore((state) => state.getAllowedCompanies)
  const getDefaultCompany = useAuthStore((state) => state.getDefaultCompany)
  const getSalesDepartment = useAuthStore((state) => state.getSalesDepartment)

  const isAuthenticated = useCallback(() => {
    return !!(user && token)
  }, [user, token])

  const login = useCallback(async (username, password, surface) => {
    try {
      const response = await authService.login(username, password, surface)
      setLogin(response.user, response.access_token, response.refresh_token)
      return { success: true, user: response.user }
    } catch (error) {
      console.error('Login failed:', error)
      return {
        success: false,
        error: error.response?.status === 401
          ? 'Kullanıcı adı veya şifre hatalı.'
          : (error.response?.data?.detail || 'Giriş başarısız. Lütfen tekrar deneyiniz.'),
      }
    }
  }, [setLogin])

  const handleLogout = useCallback(async () => {
    try {
      await authService.logout()
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      logout()
    }
  }, [logout])

  const changePassword = useCallback(async (oldPassword, newPassword) => {
    try {
      await authService.changePassword(oldPassword, newPassword)
      return { success: true }
    } catch (error) {
      console.error('Change password failed:', error)
      return {
        success: false,
        error: error.response?.data?.detail || 'Şifre değişimi başarısız.',
      }
    }
  }, [])

  return {
    user,
    token,
    isAuthenticated: isAuthenticated(),
    login,
    logout: handleLogout,
    changePassword,
    hasPermission,
    allowedCompanies: getAllowedCompanies(),
    defaultCompany: getDefaultCompany(),
    salesDepartment: getSalesDepartment(),
    setUser,
  }
}
